/** The More menu's data: OnlyFans' sidebar header from users/me, and its theme switch. */
import { isLightTheme, type Theme } from '../../theme/themes'

/** The account as OnlyFans' sidebar shows it (users/me). */
export interface MenuUser {
  name: string
  username: string
  avatar: string
  verified: boolean
  fans: number
  following: number
}

/** users/me → the sidebar's header; null when it is not a user. */
export function toMenuUser(raw: unknown): MenuUser | null {
  if (!raw || typeof raw !== 'object') return null
  const u = raw as Record<string, unknown>
  if (!u.username) return null
  const thumbs = (u.avatarThumbs && typeof u.avatarThumbs === 'object' ? u.avatarThumbs : {}) as Record<string, unknown>
  const count = (v: unknown) => (typeof v === 'number' && Number.isFinite(v) ? v : Number(v) || 0)
  return {
    name: String(u.name ?? u.username),
    username: String(u.username),
    avatar: String(thumbs.c144 || u.avatar || ''),
    verified: u.isVerified === true,
    fans: count(u.subscribersCount),
    following: count(u.subscribesCount),
  }
}

/** OnlyFans' theme switch: from a light theme to dark, from any dark one to light. */
export function nextTheme(theme: Theme): 'onlyfans-light' | 'onlyfans-dark' {
  return isLightTheme(theme) ? 'onlyfans-dark' : 'onlyfans-light'
}
